/**
 * Meet kliks op telefoonnummers en e-mailadressen.
 *
 * WAAR DIT HOORT
 * In theme.liquid, onderaan de <body> of in de <head> — de listener staat op
 * document en werkt ook voor links die later door JavaScript worden
 * toegevoegd.
 *
 * WAAROM NIET IN GTM
 * GTM draait in de sandbox van de Shopify-pixel en heeft geen toegang tot de
 * DOM van de winkelpagina. Een klik-trigger in GTM ziet hier dus niets. De
 * omweg loopt via Shopify.analytics.publish, dat een event vanuit het theme
 * naar de pixel stuurt, waar GTM het wel kan zien.
 */
(function () {
  function publiceer(naam, data) {
    if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
      window.Shopify.analytics.publish(naam, data);
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var link = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!link) return;

      var href = link.getAttribute("href") || "";

      if (href.indexOf("tel:") === 0) {
        publiceer("contact_klik", {
          soort: "telefoon",
          // Het nummer zelf is geen persoonsgegeven van de bezoeker maar van
          // de winkel; het staat op de pagina en mag mee.
          waarde: href.slice(4),
          link_tekst: (link.textContent || "").trim().slice(0, 100),
        });
      } else if (href.indexOf("mailto:") === 0) {
        publiceer("contact_klik", {
          soort: "email",
          waarde: href.slice(7).split("?")[0],
          link_tekst: (link.textContent || "").trim().slice(0, 100),
        });
      }
    },
    // Capture-fase: zo wordt de klik ook gezien als het theme hem tegenhoudt.
    true
  );
})();
